/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbEnveloppeProjetFinancementGridDto } from './FcbEnveloppeProjetFinancementGridDto';
import {
    FcbEnveloppeProjetFinancementGridDtoFromJSON,
    FcbEnveloppeProjetFinancementGridDtoFromJSONTyped,
    FcbEnveloppeProjetFinancementGridDtoToJSON,
} from './FcbEnveloppeProjetFinancementGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbEnveloppeProjetFinancementGridDtoPaginatedResults
 */
export interface FcbEnveloppeProjetFinancementGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbEnveloppeProjetFinancementGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbEnveloppeProjetFinancementGridDto>}
     * @memberof FcbEnveloppeProjetFinancementGridDtoPaginatedResults
     */
    results?: Array<FcbEnveloppeProjetFinancementGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbEnveloppeProjetFinancementGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbEnveloppeProjetFinancementGridDtoPaginatedResults interface.
 */
export function instanceOfFcbEnveloppeProjetFinancementGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbEnveloppeProjetFinancementGridDtoPaginatedResultsFromJSON(json: any): FcbEnveloppeProjetFinancementGridDtoPaginatedResults {
    return FcbEnveloppeProjetFinancementGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbEnveloppeProjetFinancementGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbEnveloppeProjetFinancementGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbEnveloppeProjetFinancementGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbEnveloppeProjetFinancementGridDtoPaginatedResultsToJSON(value?: FcbEnveloppeProjetFinancementGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbEnveloppeProjetFinancementGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

